export const ECOM_VERSION = '1.50.0-beta1';
